/* Service worker registration for UnAnonymous.
 * Quiet, opt-in feeling: registers after window load so it never blocks the first paint.
 * No prompts, no toasts — installation is the browser's job and we stay out of the user's way.
 */

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Only register on secure contexts (HTTPS or localhost). Browsers enforce this anyway,
  // but checking avoids noisy console errors on http previews.
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]";
  const isSecure = window.location.protocol === "https:" || isLocalhost;
  if (!isSecure) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Auto-activate updates next time the page reloads.
        if (reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // A new version is ready — apply it silently on next navigation.
              newWorker.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {
        // Stay silent — failing to register a SW should never disturb the user.
      });
  });
}
